import { render, staticRenderFns } from "./XhFiles.vue?vue&type=template&id=b0ab3cc6&scoped=true"
import script from "./XhFiles.vue?vue&type=script&lang=js"
export * from "./XhFiles.vue?vue&type=script&lang=js"
import style0 from "./XhFiles.vue?vue&type=style&index=0&id=b0ab3cc6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0ab3cc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0ab3cc6')) {
      api.createRecord('b0ab3cc6', component.options)
    } else {
      api.reload('b0ab3cc6', component.options)
    }
    module.hot.accept("./XhFiles.vue?vue&type=template&id=b0ab3cc6&scoped=true", function () {
      api.rerender('b0ab3cc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CreateCom/XhFiles.vue"
export default component.exports